import { AbstractTypeDriver } from './abstract';
import { RelatedType } from '../contracts';
export class QuotationDriver extends AbstractTypeDriver {
    constructor() {
        super(...arguments);
        this.typeKey = RelatedType.Quotation;
    }
    resolve(id, record, config, driverResolver) {
        const description = super.resolve(id, record, config, driverResolver);
        const { related, ...fields } = description;
        const authorDriver = driverResolver(RelatedType.Author);
        const fileDriver = driverResolver(RelatedType.File);
        const contentDriver = driverResolver(RelatedType.Content);
        let author = null;
        let article;
        let background;
        if (related.author) {
            try {
                author = authorDriver.resolve(`${related.author.value}`, record, config, driverResolver);
            }
            catch (e) {
                author = null;
            }
        }
        if (related.content) {
            try {
                article = contentDriver.resolve(`${related.content.value}`, record, config, driverResolver);
            }
            catch (e) {
                article = undefined;
            }
        }
        if (related.file) {
            try {
                background = fileDriver.resolve(`${related.file.value}`, record, config);
            }
            catch (e) {
                background = undefined;
            }
        }
        return {
            ...fields,
            author,
            background,
            article
        };
    }
}
